// extracted by mini-css-extract-plugin
export var squareCard = "SquareCard-module--squareCard--3995b";
export var squareCard__button = "SquareCard-module--squareCard__button--03bba";
export var squareCard__buttonClickable = "SquareCard-module--squareCard__buttonClickable--e7f53";
export var squareCard__button__primary = "SquareCard-module--squareCard__button__primary--06531";
export var squareCard__figure = "SquareCard-module--squareCard__figure--670a8";
export var squareCard__image = "SquareCard-module--squareCard__image--c4556";